import { ActionReducerMap } from '@ngrx/store';
import * as auth from './auth.reducers';

export interface AppState {
    auth: auth.State;
}

export const appReducers: ActionReducerMap<AppState> = {
    auth: auth.reducer
};